import React from "react";
import { Helmet } from "react-helmet-async";

export const SEO = ({ title, description }) => (
  <Helmet>
    <title>{title ? `${title} | Carepoint Health Supplies` : "Carepoint Health Supplies | Medical, Dental & Office Supplies UK"}</title>
    <meta name="description" content={description || "UK's trusted supplier of medical supplies, dental products, vet supplies, stationery and printer cartridges. Free next-day delivery on orders over £30."} />
    <meta property="og:title" content={title || "Carepoint Health Supplies"} />
    <meta property="og:description" content={description || "Medical, dental, vet supplies and printer cartridges. Free delivery over £30."} />
    <meta property="og:type" content="website" />
  </Helmet>
);
